import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { VideoWithShareStatus } from '@/types/share';
import { cn } from '@/lib/utils';

interface ShareKPISummaryProps {
  videos: VideoWithShareStatus[];
  className?: string;
}

export function ShareKPISummary({ videos, className }: ShareKPISummaryProps) {
  useLanguage();
  // Calculate KPIs
  const activeCount = videos.filter(v => v.shareLink?.status === 'active').length;
  const revokedCount = videos.filter(v => v.shareLink?.status === 'revoked').length;
  
  // Calculate copies in last 7 days
  const copiesLast7Days = videos.reduce((total, v) => {
    return total + (v.copiesCount || 0);
  }, 0);

  return (
    <div className={cn(
      "flex items-center gap-4 text-sm text-muted-foreground py-3 border-b border-border/50",
      className
    )}>
      <div className="flex items-center gap-1.5">
        <span className="font-medium text-foreground">{activeCount}</span>
        <span>{translateInterfaceText("Ativos")}</span>
      </div>
      
      <div className="w-px h-4 bg-border" />
      
      <div className="flex items-center gap-1.5">
        <span className="font-medium text-foreground">{revokedCount}</span>
        <span>{translateInterfaceText("Desativados")}</span>
      </div>
      
      <div className="w-px h-4 bg-border" />
      
      <div className="flex items-center gap-1.5">
        <span className="font-medium text-foreground">{copiesLast7Days}</span>
        <span>{translateInterfaceText("Cópias (7d)")}</span>
      </div>
      
    </div>
  );
}
